"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function defaultPromiseErrorHandler(err) {
    console.warn("Failed with the following error: %o", err);
    this.isError = true;
    return Promise.reject(err);
}
exports.defaultPromiseErrorHandler = defaultPromiseErrorHandler;
//# sourceMappingURL=common-helper-functions.js.map